import dynamic from 'next/dynamic';
import { LegalConsentProps } from './LegalConsent.types';

export const LegalConsentMGP = dynamic<LegalConsentProps>(() =>
  import('./LegalConsents').then(module => module.LegalConsent)
);
